import { cinemaGroupDomain } from '../domain/cinemaGroupDomain'

export const getSelectedCinemaGroup = () => {
    return cinemaGroupDomain.data.selected
}
